var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule, APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Dispatcher, Store } from '@ngrx/store';
import { listenForRouterMethodActions, connectRouterActions, listenForStoreChanges } from './connect';
export function setupRouterStore(router, location, dispatcher, store) {
    return function () {
        listenForRouterMethodActions(router, location, dispatcher);
        connectRouterActions(router, store);
        listenForStoreChanges(router, store);
    };
}
export function provideRouterConnector() {
    return {
        provide: APP_BOOTSTRAP_LISTENER,
        deps: [Router, Location, Dispatcher, Store],
        useFactory: setupRouterStore,
        multi: true
    };
}
var RouterStoreModule = RouterStoreModule_1 = (function () {
    function RouterStoreModule() {
    }
    RouterStoreModule.connectRouter = function () {
        return {
            ngModule: RouterStoreModule_1,
            providers: [
                provideRouterConnector()
            ]
        };
    };
    return RouterStoreModule;
}());
RouterStoreModule = RouterStoreModule_1 = __decorate([
    NgModule({})
], RouterStoreModule);
export { RouterStoreModule };
var RouterStoreModule_1;
//# sourceMappingURL=router-store-module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/router-store/src/router-store-module.js
// module id = 640
// module chunks = 1